"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { useDeferredReady } from "@/components/analytics/DeferThirdParty";

// Promo overlays are not part of the initial viewport, so their bundles
// load and mount only after first user engagement.
const PopUp = dynamic(() => import("./popUp/PopUp"), { ssr: false });
const Flyout = dynamic(() => import("./flyout/Flyout"), { ssr: false });

type PopupHeadlines = ComponentProps<typeof PopUp>["popupHeadlines"];

interface DeferredOverlaysProps {
    popUpData: { popUp: PopupHeadlines } | null | undefined;
    flyoutData: { flyOut: unknown } | null | undefined;
}

export default function DeferredOverlays({ popUpData, flyoutData }: DeferredOverlaysProps) {
    const ready = useDeferredReady();

    if (!ready) return null;

    return (
        <>
            {popUpData ? (
                <div className="print-hide">
                    <PopUp popupHeadlines={popUpData.popUp} />
                </div>
            ) : null}
            {flyoutData ? (
                <div className="print-hide">
                    <Flyout FlyoutData={flyoutData.flyOut} />
                </div>
            ) : null}
        </>
    );
}
